//import React from "react";
//import ReactDOM from "react-dom";
//import Main from "./Main";

import { loadFormSchemas } from "./formSchemaLoader"; 


(async () => {
  try {
      console.log("Loading templates...");

      const templates = config.templates; // Use the global config object

      await loadFormSchemas(templates);

      console.log("Templates loaded. Starting application...");
      // Dynamically import the main app after templates are loaded
      const { default: React } = await import("react");
      const { default: ReactDOM } = await import("react-dom");
      const { default: Main } = await import("./Main");
      await import("./index.css");

      ReactDOM.render(<Main />, document.getElementById("index"));

  } catch (error) {
      console.error("Error loading templates or application:", error);
      // Show error message to user
      const errorMessageDiv = document.getElementById("error-message");
      errorMessageDiv.textContent = "Oops! Something went wrong while loading the form templates. Please try again later.";
      errorMessageDiv.style.display = "block";
  }
})();